export default __webpack_public_path__ + "static/media/404_image.8c92d9d9.png";